<template>
  <div class="home">
    <Block v-for="(block, index) in content" :key="index" :content="block" class="block" />
  </div>
</template>

<script>
import Block from "@/components/Block.vue";

export default {
  name: "home",
  components: {
    Block
  },
  props: {
    content: Array
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: bold;
  src: url(../../public/fonts/Raleway-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "MarkaziText_allens";
  font-style: normal;
  font-weight: normal;
  src: url(../../public/fonts/MarkaziText_allens.ttf) format("truetype");
}

.home {
  display: flex;
  flex-direction: row;
  overflow: visible;

  .block {
    height: 30vh;
  }
}
</style>

